import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgUserEditBulk = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 25 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m19.914 14.434-.71-.71c-.608-.507-1.42-.406-1.927.102l-3.245 3.549q-.608.608-.608 1.217l-.102.811c-.101.406.102.71.305 1.014.202.203.507.304.81.304h.204l.81-.101c.508-.101.914-.304 1.42-.811l3.144-3.448c.406-.507.406-1.42-.101-1.927M11.091 3.178a4.664 4.664 0 0 1 4.665 4.665 4.664 4.664 0 0 1-4.665 4.665 4.664 4.664 0 1 1 0-9.33"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10.077 14.535c-1.42 0-2.738.203-3.752.507-.609.203-1.217.507-1.623.913a2.45 2.45 0 0 0-.71 1.724c0 .71.203 1.217.71 1.724.406.405 1.014.71 1.623.912 1.014.305 2.332.507 3.752.507.608 0 1.014-.405 1.014-1.014V15.55c0-.608-.406-1.014-1.014-1.014"
      clipRule="evenodd"
      opacity={0.4}
    />
  </svg>
);
const ForwardRef = forwardRef(SvgUserEditBulk);
export default ForwardRef;
